export const CONSULTANT_NAME = 'Júlio Amaral';
export const CONSULTANT_PHOTO_URL = '/FotoJulioAmaral.webp';
export const AGENCY_NAME = 'Century 21 Contacto Directo';

export const CONTACT_INFO = {
  whatsapp: 'https://wa.me/351935962810',
  phone: '935 962 810',
  email: 'julio.amaral@century21.pt',
  website: 'https://julio-amaral.century21.pt/comprar',
  address: 'https://maps.app.goo.gl/j3DsHmkFPTcG9TWi6',
  addressText: 'C21 Contacto Directo, Setúbal',
};

